import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";
import { H3TagStyle } from "../../components/TextStyles/TextStyles.style";

type HorizontalDividerProps = {
  height: string;
  width: string;
  backgroundColor: string;
};

export const InsuranceLandingPageMainWrapper = styled.div`
  background-image: linear-gradient(rgba(5, 19, 34, 1), rgba(21, 69, 124, 1));
  background-size: 100% 990px;
  background-repeat: no-repeat;
  padding-top: 16px;
  position: relative;
  z-index: 2;
  @media ${deviceType.mobile} {
    background-image: none;
    /* background: #000; */
    padding-top: 0px;
  }
`;

export const InsuranceLandingMyPartnerPageMainWrapper = styled.div`
  background-image: linear-gradient(180deg, #282a47 0.38%, #554276 100%);
  background-size: 100% 990px;
  background-repeat: no-repeat;
  padding-top: 16px;
  position: relative;
  z-index: 2;
  .userSection {
    img,
    picture {
      flex-shrink: 1;
    }
  }
  @media ${deviceType.mobile} {
    background-image: none;
    /* background: #000; */
    padding-top: 0px;
  }
`;

export const InsuranceGiLandingPageMainWrapper = styled.div`
  padding-top: 16px;
  position: relative;
  z-index: 2;
  &:after {
    content: "";
    position: absolute;
    top: 240px;
    width: 100%;
    left: 0;
    background-color: #eff3f8;
    height: 1200px;
    z-index: 1;
  }
  :before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    background-image: url("https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831888_401a4765df.png");
    background-size: 100% 382px;
    background-repeat: no-repeat;
    height: 382px;
    z-index: 2;
  }
  @media ${deviceType.mobile} {
    background-image: none;
    /* background: #000; */
    padding-top: 0px;
    &:after {
      background-color: transparent;
    }
  }
`;

export const PersuasionWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  ${H3TagStyle} {
    max-width: 60%;
  }
`;

export const LandingPageRightWrapper = styled.div<{rightCompMargin: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: ${props => props.rightCompMargin ? "50px" : "0px"};
  @media ${deviceType.mobile} {
    margin-top: 0px;
  }
`;

export const GiFooterWrap = styled.div`
  width: 100%;
`;

export const HorizontalDivider = styled.div<HorizontalDividerProps>`
  ${(props) => `height: ${props.height}`};
  ${(props) => `width: ${props.width}`};
  ${(props) => `background-color: ${props.backgroundColor}`};
`;
